import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function FinalCTA() {
  const { i18n } = useTranslation();
  const { finalCta } = getLandingContent(i18n.language);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 md:py-28 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 px-6 md:px-10 lg:px-16 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 md:mb-8 leading-tight max-w-3xl mx-auto">
          {finalCta.title}
        </h2>
        <p className="text-base md:text-lg text-gray-400 max-w-xl mx-auto mb-10 md:mb-12 leading-relaxed">
          {finalCta.subtitle}
        </p>
        <a
          href="#contact"
          onClick={(e) => handleScroll(e, '#contact')}
          className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-hover text-white font-medium px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-base"
        >
          {finalCta.button}
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}
